export default __webpack_public_path__ + "static/media/usd-flag.a60074bd.svg";